//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Link } from 'react-router-dom';
import { Grid } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { clearFilters } from '@/redux/slices/dataTableSlice';
import { selectDataTableAppliedSearchName, selectTableTitle } from '@/redux/selectors/dataTableSelectors';
import { Breadcrumbs, Title, TitleBar } from '@/components/_common';

const ExceptionsTitleBar = () => {
  const dispatch = useAppDispatch();
  const appliedSearchName = useAppSelector(selectDataTableAppliedSearchName);
  const pageTitle = useAppSelector(selectTableTitle) || 'Exceptions';

  const onBreadcrumbClick = () => {
    dispatch(clearFilters());
  };

  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        {!appliedSearchName ? (
          <Title>{pageTitle}</Title>
        ) : (
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/exceptions" onClick={onBreadcrumbClick}>
              {pageTitle}
            </Link>
            <span>&ldquo;{appliedSearchName}&ldquo;</span>
          </Breadcrumbs>
        )}
      </Grid>
    </TitleBar>
  );
};

export default ExceptionsTitleBar;
